import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurServicesOverview from "./sections/OurServicesOverview";
import WhoWeServeSnapshot from "./sections/WhoWeServeSnapshot";
import ComplianceSecurityHighlights from "./sections/ComplianceSecurityHighlights";
import GetStartedCallToAction from "./sections/GetStartedCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurServicesOverview />
      <WhoWeServeSnapshot />
      <ComplianceSecurityHighlights />
      <GetStartedCallToAction />
      <Footer />
    </div>;
}